const parseIsoCurrency = (rawCurrency) => {
  if(['₺', 'TL'].includes(rawCurrency.toUpperCase?.())) {
    return 'TRY';
  }

  return rawCurrency;
}

export default parseIsoCurrency;